import { PUSH_BREADCRUMB, PUSH_MULTIPLE_BREADCRUMBS } from 'esm-web-pro/redux/breadcrumb/constants';
import {
    CLOSE_BY_KEY, CLOSE_TOPMOST, OPEN, SET_TITLE,
} from 'esm-web-pro/redux/side-panel/constants';
import updateDocumentTitle from 'esm-web-pro/redux/documentTitle/actions';
import { getSidePanelState, hasOpenedPanels } from 'esm-web-pro/redux/side-panel';
import getBreadcrumbs from 'esm-web-pro/redux/breadcrumb/selectors';
import isEmpty from 'lodash/isEmpty';

const updateDocumentTitleMiddleware = (store) => (next) => (action) => {
    const result = next(action);

    const openedPanels = hasOpenedPanels(store.getState());
    const breadcrumbs = getBreadcrumbs(store.getState());
    const sidePanelState = getSidePanelState(store.getState());

    if ((action.type === OPEN || action.type === SET_TITLE) && action.payload.title) {
        // set the document title to the title of the side panel
        store.dispatch(updateDocumentTitle(action.payload.title));
    } else if (action.type === CLOSE_TOPMOST || action.type === CLOSE_BY_KEY) {
        if (openedPanels) {
            const sidePanelKey = Object.keys(sidePanelState).pop();
            store.dispatch(updateDocumentTitle(sidePanelState[sidePanelKey].title));
        } else if (!isEmpty(breadcrumbs)) {
            store.dispatch(updateDocumentTitle(breadcrumbs[breadcrumbs.length - 1].title));
        }
    } else if (action.type === PUSH_MULTIPLE_BREADCRUMBS && !openedPanels) {
        store.dispatch(updateDocumentTitle(action.payload.breadcrumbs[action.payload.breadcrumbs.length - 1].title));
    } else if (action.type === PUSH_BREADCRUMB && !openedPanels) {
        store.dispatch(updateDocumentTitle(action.payload.title));
    }

    return result;
};

export default updateDocumentTitleMiddleware;
